import { render, staticRenderFns } from "./htmlReader.vue?vue&type=template&id=6054466d&scoped=true&"
import script from "./htmlReader.vue?vue&type=script&lang=js&"
export * from "./htmlReader.vue?vue&type=script&lang=js&"
import style0 from "./htmlReader.vue?vue&type=style&index=0&id=6054466d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054466d",
  null
  
)

export default component.exports